import { combineReducers } from 'redux';

import { REDUCER_NAME as START_MANIFESTING_REDUCER_NAME } from './StartManifest/constants';
import startManifestingReducer from './StartManifest/reducer';

export default combineReducers({
  [START_MANIFESTING_REDUCER_NAME]: startManifestingReducer,
});
